import type { ServiceClient } from '../http/client';
import type { GroupRevision } from './access-groups';
import {
  parseAccessMember,
  parseMemberPage,
  parseMemberResult,
  type AccessMember,
  type MemberPage,
  type MemberResult,
} from './access-members';

/** 관리자는 숙박과 방문 기간을 지정해 비회원 게스트를 초대한다. */
export interface GuestInvitationInput {
  command_id: string;
  id: string;
  stay_id: string;
  name: string;
  phone: string;
  visit_start: string;
  visit_end: string;
}
export interface GuestInvitationPeriod extends GroupRevision {
  visit_start: string;
  visit_end: string;
}
export async function readGuestInvitations(
  client: ServiceClient,
  signal?: AbortSignal,
  cursor?: string,
): Promise<MemberPage> {
  return parseMemberPage(
    await client.get<unknown>('admin/guest-invitations', {
      ...(cursor ? { params: { cursor } } : {}),
      signal,
      headers: { 'Cache-Control': 'no-store' },
    }),
  );
}
export async function readGuestInvitation(
  client: ServiceClient,
  id: string,
  signal?: AbortSignal,
): Promise<AccessMember> {
  return parseAccessMember(
    await client.get<unknown>(`admin/guest-invitations/${id}`, {
      signal,
      headers: { 'Cache-Control': 'no-store' },
    }),
  );
}
export async function createGuestInvitation(
  client: ServiceClient,
  body: GuestInvitationInput,
): Promise<MemberResult> {
  return parseMemberResult(
    await client.post<unknown>('admin/guest-invitations', { json: body }),
    body.id,
  );
}
export async function updateGuestInvitation(
  client: ServiceClient,
  id: string,
  body: GuestInvitationPeriod,
): Promise<MemberResult> {
  return parseMemberResult(
    await client.patch<unknown>(`admin/guest-invitations/${id}`, { json: body }),
    id,
  );
}
export async function cancelGuestInvitation(
  client: ServiceClient,
  id: string,
  body: GroupRevision,
): Promise<MemberResult> {
  return parseMemberResult(
    await client.delete<unknown>(`admin/guest-invitations/${id}`, { json: body }),
    id,
  );
}
